// @ts-nocheck

/**
 * * `system` - System
 * `user_generated` - User Generated
 */
export type AssetTypeEnum = typeof AssetTypeEnum[keyof typeof AssetTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssetTypeEnum = {
  system: "system",
  user_generated: "user_generated",
} as const;
